/* global width:true */
/* eslint no-undef: "error" */

import React from "react";
import { LoadMoreCollectionStories } from "@quintype/components";
import { func, array, bool, object } from "prop-types";
import get from "lodash/get";

import Headline from "../atoms/headline";
import CardImageType9 from "../molecules/card-image-type-9";
import CardImageType10 from "../molecules/card-image-type-10";
import ReadMore from "../atoms/read-more";
import TwitterIcon from "../atoms/icons/twitter/index";
import DfpAd from "../dfp-ad";

import "./author.m.css";
import SideBar from "./section/sidebar";

const storiesDom = stories => {
  return stories.map((item, index) => (
    <React.Fragment key={index}>
      <div styleName="set-1-story">
        {index % 3 === 0 ? (
          <CardImageType9 story={item.story || item} page="author-page" />
        ) : (
          <CardImageType10 story={item.story || item} page="author-page" />
        )}
      </div>
      {index + 1 === 8 && (
        <div styleName="ad">
          <DfpAd adtype="leaderboard_2_728x90" />
        </div>
      )}
      {(index + 1) % 4 === 0 &&
        index + 1 >= 12 && (
          <div styleName="ad">
            <DfpAd adtype="leaderboard_2_728x90" />
          </div>
        )}
    </React.Fragment>
  ));
};

const storiesTemplate = ({ onLoadMore, stories, noMoreStories }) => (
  <div styleName="stories-list">
    {storiesDom(stories)}
    {!noMoreStories && stories.length >= 20 && <ReadMore onClick={onLoadMore} />}
  </div>
);

const authorBio = author => (
  <div styleName="author-bio">
    {author["avatar-url"] && (
      <div className="author-image">
        <img styleName="picture" src={author["avatar-url"]} alt={author.name} />
      </div>
    )}
    <div>
      {author.name && <h1 styleName="name">{author.name}</h1>}
      {author["twitter-handle"] && (
        <a
          styleName="link"
          href={`https://www.twitter.com/${author["twitter-handle"]}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <TwitterIcon color={"#1da1f2"} />
          <span>@{`${author["twitter-handle"]}`}</span>
        </a>
      )}
      <div styleName="bio" dangerouslySetInnerHTML={{ __html: author.bio }} />
    </div>
  </div>
);

class AuthorPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      width: null
    };
  }
  isWidthPresent = () => {
    this.setState({ width });
  };

  componentDidMount() {
    this.isWidthPresent();
  }

  render() {
    const { data } = this.props;
    const getAuthor = data.author;
    const authorPageHeadline = `Stories By ${data.author.name}`;

    const trendingCollection = get(data, ["trendingCollection", "collection"], {});
    const webSpecialCollection = get(data, ["webSpecialCollection", "collection"], {});
    const opinionsCollection = get(data, ["opinionsCollection", "collection"], {});
    const horoscopeCollection = get(data, ["horoscopeCollection", "collection"], {});
    const viralCollection = get(data, ["viralCollection", "collection"], {});

    return (
      <div styleName="wrapper">
        {this.state.width <= 992 && (
          <div className="dfp-ad">
            <DfpAd adtype="banner_2_300x100" />
          </div>
        )}
        {Object.keys(getAuthor).length === 0 ? (
          <div>
            <Headline text="Author not found! " headerType={12} headerLevel={3} />
          </div>
        ) : (
          <div>
            {authorBio(data.author)}
            <div styleName="author-page-header">
              <Headline text={authorPageHeadline} headerType={12} headerLevel={3} />
            </div>
            <LoadMoreCollectionStories
              template={storiesTemplate}
              data={{ stories: data.stories }}
              authorId={data.author.id}
              numStoriesToLoad={4}
            />
          </div>
        )}
        <div className="sidebar" styleName="sidebar">
          <SideBar
            trendingCollection={trendingCollection}
            webSpecialCollection={webSpecialCollection}
            opinionsCollection={opinionsCollection}
            horoscopeCollection={horoscopeCollection}
            viralCollection={viralCollection}
          />
        </div>
      </div>
    );
  }
}

storiesTemplate.propTypes = {
  onLoadMore: func,
  stories: array,
  noMoreStories: bool
};

AuthorPage.propTypes = {
  data: object
};

export { AuthorPage };
